import React from 'react'
import { Helmet } from 'react-helmet'
import { generateAlternateLinks, generateTitleAndMetaTags } from 'src/utils/seo'

const SeoMgLearning = ({ title, description }) => {
  return (
    <Helmet>
      {generateTitleAndMetaTags(title, description)}
      {generateAlternateLinks('/education/matrixgold')}
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "MatrixGold Learning",
            "description": "Start learning today, and become a jewelry design expert. Whether you are a novice, expert, student, or professional, we have a training path for you. Choose the option best suited to your style of learning.",
            "item": "https://gemvision.com/education/matrixgold"  
          }]
        }`}
      </script>
    </Helmet>
  )
}

export default React.memo(SeoMgLearning)
